import React from "react";
import { CircularProgress } from "@mui/material";
export default function CircularProgressCenter() {
  return (
    <div className="loading-container">
      <CircularProgress />
    </div>
  );
}
